module.exports = __webpack_public_path__ + "img/SwapTokenLoading.42d0bca9.svg";